import { writable } from 'svelte/store';

let isLoaded = false; 

export const useMarkers =  () => {
  
  //const CHECK_INTERVAL = 10_000;
  const CHECK_INTERVAL = 1000;
  //let data = null;
  let checkInterval = null;
  let markers = {};

  let anyMarker = writable({isValid:false})  

  



  async function  loadMarkers() {
	if (isLoaded) return
    isLoaded = true;
    try{
	
		const url =
		window.location.hostname === "localhost"
			? "./marker.json"
			: process.env.NODE_ENV === "production"
			? `${process.env.DATA_PATH}/marker.json`
			: `${process.env.DEV_DATA_PATH}/marker.json`;
      
      const  response = await fetch(url);
      const  result = await response.json();
      

      fillMarkers(result)
      activate()
      
      //return result

      }catch(e){
        console.error(e);
        
        //return null;
      }
   } 


    const deactivateMarker = () => {
      
    if (checkInterval) clearInterval(checkInterval)
      isLoaded = false
      

    }


  const activate = async () => {
    if (!isLoaded){
      try{
         await loadMarkers()
      }catch(e){
        
        console.error(e);
      }
    }

    if (checkInterval) return
    //console.log("ACTIVATE marker | set interval")



    checkInterval = setInterval(
      () => {
      
      //updateMarkers()
      updateAnyMarkers()
    }, CHECK_INTERVAL);
  }


  // function updateMarkers(){

  //   Object.values(markers).forEach(
  //      (markerStore) => {
  //     markerStore.update(marker => (
  //       {
  //       ...marker,
  //       isValid: marker.endAt > Date.now(),
  //     }))
  //   })
  // }

  function updateAnyMarkers(){
    //console.log("|##### check all markers   #####|")
    let result = false
    for (let key in markers){
      let marker = markers[key]
      //console.log("    marker.endAt: "+marker.endAt + " date: "+ Date.now())
      if (marker.endAt>=Date.now()){
        
        //console.log("VALID marker")
          result = true 
          break
        }
            //anyMarker.update((value)=>({...value,isValid:true}))
    }

    anyMarker.update((value)=>({...value,isValid:result}))
    //console.log(`|#####  ${result}   #####|`)
  }

  

  
 //private 
 function createMarker(data){
    //return writable(data)
    return data
}

  
const fillMarkers = (data)=> { 
  data?.markers.forEach((newMarker)=>{
      markers[newMarker.path] = createMarker(newMarker)
  })

}


  

  loadMarkers()

  return {anyMarker, deactivateMarker};
};


